import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { Input } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";

const nameValidator = value => {
  return !value || (value && value.length < 1) ? "Name is required." : "";
}

const FormInput = (fieldRenderProps) => {
  const { validationMessage, visited, ...others } = fieldRenderProps;
  return (
    <div>
      <Input {...others} />
      {visited && validationMessage && <Error>{validationMessage}</Error>}
    </div>
  );
};

const GroupModal = (props) => {
  return <Dialog title={props.item.id ? 'Edit Group' : 'Create Group'} onClose={props.cancelEdit} className='flo-kendo-dialog'>
    <Form
      onSubmit={(e) => props.saveGroup(e)}
      initialValues={props.item}
      render={(formRenderProps) => (
        <FormElement style={styles.formElement}>
          <fieldset className={"k-form-fieldset"}>
            <div className="mb-3">
              <Field name={"name"} component={FormInput} label={"Name"} validator={nameValidator} />
            </div>
          </fieldset>
          <div className="k-form-buttons k-justify-content-end">
            <button type={"submit"} className="k-button k-primary" style={styles.modalBtn} disabled={!formRenderProps.allowSubmit}>
              Save
            </button>
            <button type={"submit"} className="k-button" style={styles.modalBtn} onClick={props.cancelEdit}>
              Cancel
            </button>
          </div>
        </FormElement>
      )}
    />
  </Dialog>
}

const styles = {
  formElement: {
    maxWidth: 650,
    minWidth: 275,
  },
  modalBtn: {
    padding: '10px 15px',
  },
}

export default GroupModal;